import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Contingentes } from '../models/contingentes';

const baseUrl = environment.hostService + '/PersonalContingentes';

@Injectable({
  providedIn: 'root'
})
export class ContingentesService {

  constructor(private _http: HttpClientService) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index' })
  }

  getByPersonal(id: number, agrupar: boolean): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/GetByPersonalId/' + id + '/' + agrupar })
  }

  calcularConsumo(id: number): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/CalcularDiasConsumidos?id=' + id})
  }

  getHistoryByClase(idPersonal: number, claseContingente: number): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/GetHistoryByClase/' + idPersonal + '/' + claseContingente });
  }

  guardar(data, cortarRegistro): Observable<any>
  {
    return this._http.post<any>({ url: baseUrl + '/Save/' + cortarRegistro, body: data, cacheMins: 0 });
  }

  eliminar(id: number)
  {
    return this._http.get<any>({ url: baseUrl + '/Delete?id=' + id });
  }

  getFormatoImportacion() {
    const formato = [
      { personal: 0,
        desde: '00/00/0000',
        hasta: '00/00/0000',
        claseContingente: '', 
        inicioLiquidacion: '00/00/0000',
        finLiquidacion: '00/00/0000',
        cantidad: '',
        errores: ['No Completar']}
    ];

    //claseContingente se deben validar que existan

    return formato;
  }
}
